import { MutationTree } from "vuex";
import { Reimbursement } from "./types";

export const mutations: MutationTree<Reimbursement> = {
  SET_REFRESH(state, payload: boolean) {
    state.refresh = payload;
  },
};
